import { QuestInstance, SessionBooking } from "@joonapp/web-shared"
import { User } from "@joonapp/web-shared"

export enum CoachTodoType {
  SIGN_TOS = "sign_tos", // Email user to sign tos. An onboarding notification
  FIRST_SESSION = "first_session", // Email user to book first session (only if session based plan). An onboarding notification
  VIDEO_GREETING = "video_greeting", // Reminder to send video greeting. An onboarding notification
  REENGAGED_MESSAGE = "reengaged_message", // When user goes from inactived to reactived (see above)∫.
  DOCUMENT_SESSION = "document_session", // When a session is finished and the user has not made their notes visible. Will have the `associated_session` property set.
  NEXT_SESSION = "next_session", // User has session based plan, has had at least one session before, but does not have any future sessions.
  WEEKLY_ROUTINE = "weekly_routine", // Will be created on Thursdays if the coach has not created a Quest or a Scheduled Message for next week.
  TEXT_CHECKIN = "text_checkin", // For text based plans, if coach has not sent a message in past 2 days.
  QUEST_COMPLETION = "quest_completion", // Created when the client completes their assigned quest
}

export interface CoachTodo {
  id: number
  type: CoachTodoType
  client: User // The user that the todo is for
  completed: boolean // true if it's been marked as dismissed or has already been completed
  date_completed: string | null // If non-null, means it has been completely finished.
  date_dismissed_until: string | null // If user dismisses notification, we will hide it for 2 days and then show it again.
  associated_quest: QuestInstance | null // non-null if `type` is `quest_completion`
  associated_session: SessionBooking | null // non-null if `type` is `document_session`
}
